<div *ngIf="data.dialogTitle" mat-dialog-title class="dialog_info-dialog-title">{{data.dialogTitle}}</div>
<div *ngIf="data.dialogContent" class="dialog_info-dialog-content">{{data.dialogContent}}</div>

<mat-dialog-actions align="end">
    <button mat-button (click)="dialogActionSelected('cancel')" class="dialog__info-dialog-button-close">{{(data.cancelButtonText)?data.cancelButtonText:'Cancel'}}</button>
    <button mat-button (click)="dialogActionSelected('accept')" class="dialog__info-dialog-button-close ">{{(data.confirmButtonText)?data.confirmButtonText:'Change'}}</button>
</mat-dialog-actions>